// src/components/common/DonateButton.jsx
import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";

const DonateButton = ({ className = "", to = "/donation" }) => {
  const { lang } = useContext(LanguageContext);
  const label = lang === "mr" ? "देणगी" : "Donate";

  return (
    <NavLink className={`cta-donate ${className}`} to={to}>
      {label}
    </NavLink>
  );
};

export default DonateButton;
